/* eslint-disable no-plusplus */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-console */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
import React from 'react';
import { Controller } from 'react-hook-form';
import { FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
export const EventsFilter = ({
  name,
  label,
  list,
  allText,
  watch,
  control,
  updateOnChange,
}) => {
  return (
    <Controller
      name={`${name}-filter`}
      control={control}
      render={({ field: { onChange, ref } }) => (
        <FormControl size="small">
          <InputLabel
            id={`lbl-${name}-filter`}
            margin="none"
            className="select-label"
          >
            {label}
          </InputLabel>
          <Select
            MenuProps={{
              autoWidth: true,
              anchorOrigin: {
                vertical: 'top',
                horizontal: 'left',
              },
              transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
              },
              getContentAnchorEl: null,
              PaperProps: { style: { maxHeight: '500px' } },
            }}
            labelId={`lbl-${name}-filter`}
            id={`ctrl-${name}-filter`}
            label={label}
            autoWidth
            variant="outlined"
            onChange={async (e) => {
              onChange(e);
              updateOnChange(e);
            }}
            value={watch(`${name}-filter`)}
            inputRef={ref}
          >
            <MenuItem value={allText}>{allText}</MenuItem>
            {list &&
              list.map((item, i) => {
                return (
                  <MenuItem key={i} value={item.id}>
                    {item.name}
                  </MenuItem>
                );
              })}
          </Select>
        </FormControl>
      )}
    />
  );
};
